const quizUrl = '/quiz';

export default quizUrl;
